import axios from 'axios'

const api = axios.create({
  baseURL: 'https://adminapp.blueteamuae.xyz',
});

export default api